/**
 * event handling for possibly live changing elements: 
 * delegate('.list-item', 'click', (e) => { ... - instead of globalThis.on, which, collides with some other libraries
 */
export function delegate(eventType, selector, handler) {
    document.addEventListener(eventType, function(event) {
        const targets = document.querySelectorAll(selector);
        for(let i = 0; i < targets.length; i++) {
            let el = event.target;
            while(el) {
                if(el === targets[i]) {
                    handler.call(el, event);
                    return;
                }
                el = el.parentNode;
            }
        }
    }, { 
        capture: true 
    });
}

/**
 * create html-element from string
 */
export function create(string) {
    const template = document.createElement('template');
    template.innerHTML = string.trim();
    return template.content.firstChild;
}